<ng-template [ngIf]="element.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Cognome e Nome'" [valueInput]="element.parte?.nominativo"></div>
	<!--<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Matricola'" [valueInput]="element.parte?.matricola"></div>-->
	<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Codice fiscale'" [valueInput]="element.parte?.codiceFiscale"></div>
</ng-template>
<ng-template [ngIf]="element.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
	<div labelTextInput class="col-sm-5 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Ragione sociale'" [valueInput]="element.parte?.nominativo"></div>
	<div labelTextInput class="col-sm-5 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Partita iva'" [valueInput]="element.parte?.partitaIva"></div>
</ng-template>
	<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'boolean'"
		[labelInput]="'Primaria'" [valueInput]="element.primario"></div>
